import { render } from "./MultiStatsCard.vue?vue&type=template&id=2c1ab898"
import script from "./MultiStatsCard.vue?vue&type=script&lang=js"
export * from "./MultiStatsCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__